import React from 'react';
import DeviceScanCard from '../../../../components/DeviceScan/DeviceScanCard';
import useDeviceScanSession from '../../../../components/DeviceScan/useDeviceScanSession';

function DeviceScan(props) {
    const { natural_person } = props;
    const { deviceScan, sdkMetadata } = useDeviceScanSession(
        natural_person.company_key,
        natural_person.source?.session_id
    );

    return (
        <DeviceScanCard
            deviceScan={deviceScan}
            channel={natural_person.source?.channel}
            sdkMetadata={sdkMetadata}
        />
    );
}

export default DeviceScan;
